import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type DotProps = ComponentProps<"span"> & {
  variant:
    | "primary"
    | "secondary"
    | "info"
    | "success-1"
    | "success-2"
    | "warning"
    | "orange"
    | "destructive"
    | "muted"
}

function Dot(props: DotProps) {
  const { variant = "primary", className, ...spanProps } = props
  return (
    <span className={cn("dot", `dot-${variant}`, className)} {...spanProps} />
  )
}

export default Dot
